import { render } from "./GiftAidModal.vue?vue&type=template&id=91224336"
import script from "./GiftAidModal.vue?vue&type=script&lang=js"
export * from "./GiftAidModal.vue?vue&type=script&lang=js"

import "./GiftAidModal.vue?vue&type=style&index=0&id=91224336&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__